import { Rating } from "@material-tailwind/react";

export function ReadonlyRating() {
  return <Rating value={4} readonly />;
}
